<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="legal-content">

  <!-- CONDICIONES DE USO -->
  <ng-container *ngIf="section === 'condiciones'">
    <p><strong>Titular:</strong> {{ marca.titular.nombre }} · NIF: {{ marca.titular.nif }} · {{ marca.titular.email }}</p>

    <h3>1. Objeto</h3>
    <p>
      La presente plataforma de gestión (en adelante, «la Plataforma») es una herramienta privada de uso profesional
      puesta a disposición de los clientes de {{ marca.nombre }} para el seguimiento de encargos técnicos,
      consulta de documentación, facturas y comunicación con el despacho.
    </p>

    <h3>2. Acceso</h3>
    <p>
      El acceso está restringido a personas físicas previamente autorizadas por {{ marca.nombre }}.
      Cada usuario dispone de credenciales personales e intransferibles. El titular de la cuenta
      es responsable del uso que se haga con sus credenciales.
    </p>

    <h3>3. Uso aceptable</h3>
    <p>
      El usuario se compromete a utilizar la Plataforma exclusivamente para los fines para los que ha sido
      autorizado, sin reproducir, distribuir ni divulgar la información a la que accede sin consentimiento
      previo y por escrito de {{ marca.nombre }}.
    </p>

    <h3>4. Disponibilidad</h3>
    <p>
      {{ marca.nombre }} no garantiza la disponibilidad ininterrumpida de la Plataforma y podrá realizar
      operaciones de mantenimiento con o sin previo aviso.
    </p>

    <h3>5. Modificaciones</h3>
    <p>
      {{ marca.nombre }} se reserva el derecho a modificar estas condiciones en cualquier momento.
      Los cambios relevantes se comunicarán a los usuarios mediante la Plataforma o por correo electrónico.
    </p>

    <h3>6. Legislación aplicable</h3>
    <p>
      Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier
      controversia, las partes se someten a los juzgados y tribunales de Ibiza.
    </p>
  </ng-container>

  <!-- PROTECCIÓN DE DATOS -->
  <ng-container *ngIf="section === 'privacidad'">
    <p><strong>Responsable del tratamiento:</strong> {{ marca.titular.nombre }} · NIF: {{ marca.titular.nif }}</p>
    <p><strong>Contacto:</strong> {{ marca.emailContacto }}</p>

    <h3>1. Finalidad del tratamiento</h3>
    <p>
      Los datos personales recabados se tratan para la prestación de los servicios de ingeniería y gestión
      técnica contratados, la gestión administrativa y de facturación, y el acceso a la Plataforma.
      Con su consentimiento expreso, también para el envío de comunicaciones informativas sobre la Plataforma.
    </p>

    <h3>2. Base jurídica</h3>
    <ul>
      <li>Ejecución del contrato de servicios profesionales (art. 6.1.b RGPD).</li>
      <li>Cumplimiento de obligaciones legales, incluida la normativa fiscal y de facturación (art. 6.1.c RGPD).</li>
      <li>Consentimiento del interesado para comunicaciones informativas (art. 6.1.a RGPD).</li>
    </ul>

    <h3>3. Conservación de datos</h3>
    <p>
      Los datos se conservarán durante la vigencia de la relación profesional y, posteriormente,
      durante los plazos legalmente exigibles (5 años para obligaciones fiscales y mercantiles,
      10 años en materia de blanqueo de capitales).
    </p>

    <h3>4. Destinatarios</h3>
    <p>
      No se cederán datos a terceros salvo obligación legal. La Plataforma utiliza servicios de
      infraestructura en la nube (Amazon Web Services), base de datos en la nube (MongoDB Atlas,
      MongoDB Inc.) y autenticación (Google Firebase), cuyos proveedores actúan como encargados
      del tratamiento bajo las garantías del RGPD.
    </p>

    <h3>5. Derechos del interesado</h3>
    <p>
      Puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y
      portabilidad dirigiéndose a {{ marca.emailContacto }}, adjuntando copia de su DNI.
      También puede presentar reclamación ante la Agencia Española de Protección de Datos
      (<a href="https://www.aepd.es" target="_blank">www.aepd.es</a>).
    </p>

    <h3>6. Comunicaciones comerciales</h3>
    <p>
      El envío de comunicaciones informativas sobre la Plataforma está condicionado a su consentimiento
      previo y expreso, que puede retirar en cualquier momento desde su perfil en la Plataforma
      o mediante el enlace de baja incluido en cada comunicación.
    </p>
  </ng-container>

  <!-- USO INDIVIDUAL -->
  <ng-container *ngIf="section === 'uso-individual'">
    <h3>Acceso personal e intransferible</h3>
    <p>
      Cada cuenta de acceso a la Plataforma está asociada a una persona física concreta
      y es de uso estrictamente personal e intransferible. Queda prohibido compartir
      las credenciales de acceso con terceros, incluidos otros miembros de la misma organización.
    </p>

    <h3>Ámbito de la información accesible</h3>
    <p>
      El usuario solo tiene acceso a la información relativa a los encargos, documentos y
      expedientes en los que ha sido expresamente autorizado por {{ marca.nombre }}.
      El acceso a información ajena a dicha autorización queda prohibido.
    </p>

    <h3>Trazabilidad de acciones</h3>
    <p>
      La Plataforma registra los accesos y las acciones realizadas por cada usuario.
      {{ marca.nombre }} podrá revocar el acceso en caso de uso indebido o incumplimiento
      de las presentes condiciones, sin perjuicio de las acciones legales que pudieran corresponder.
    </p>

    <h3>Confidencialidad</h3>
    <p>
      Toda la información a la que el usuario accede a través de la Plataforma tiene carácter
      confidencial. El usuario se compromete a no divulgar, reproducir ni utilizar dicha información
      para fines distintos a los que motivaron su autorización de acceso.
    </p>

    <h3>Solicitud de acceso adicional</h3>
    <p>
      Si necesitas autorizar el acceso de otras personas de tu organización, contacta directamente
      con {{ marca.nombre }} en {{ marca.emailContacto }}.
    </p>
  </ng-container>


  <!-- POLÍTICA DE COOKIES -->
  <ng-container *ngIf="section === 'cookies'">
    <p><strong>Responsable:</strong> {{ marca.titular.nombre }} · NIF: {{ marca.titular.nif }} · {{ marca.titular.email }}</p>

    <h3>1. Qué son las cookies</h3>
    <p>
      Las cookies son pequeños ficheros que un sitio web almacena en el navegador del usuario.
      La Plataforma hace un uso mínimo y estrictamente técnico de cookies, sin utilizarlas
      con fines publicitarios ni de seguimiento de comportamiento.
    </p>

    <h3>2. Cookies propias</h3>
    <p>
      La Plataforma <strong>no establece cookies propias</strong>. La sesión de usuario
      se gestiona mediante tokens almacenados en el almacenamiento local del navegador
      (<em>localStorage</em>), que no son cookies y no se transmiten automáticamente
      al servidor en cada petición.
    </p>

    <h3>3. Cookies de Google Maps</h3>
    <p>
      El módulo de mapa utiliza la API de Google Maps (Google LLC). Al acceder a la sección
      de Mapa, Google puede establecer cookies técnicas necesarias para renderizar los mapas
      interactivos y garantizar su correcto funcionamiento. Estas cookies son gestionadas
      íntegramente por Google bajo su propia
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Política de Privacidad</a>.
    </p>
    <p>
      La base jurídica para este tratamiento es el interés legítimo en proporcionar
      la funcionalidad cartográfica de la Plataforma (art. 6.1.f RGPD).
    </p>

    <h3>4. Cómo gestionar o deshabilitar las cookies</h3>
    <p>
      Puede configurar su navegador para bloquear o eliminar cookies en cualquier momento.
      Tenga en cuenta que bloquear las cookies de Google Maps puede impedir el funcionamiento
      del módulo de mapa. El resto de la Plataforma seguirá funcionando con normalidad.
    </p>

    <h3>5. Actualizaciones</h3>
    <p>
      Esta política puede actualizarse si se incorporan nuevos servicios que utilicen cookies.
      Cualquier cambio relevante se comunicará a través de la Plataforma.
    </p>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="close()">Cerrar</button>
</mat-dialog-actions>
